import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const INTRO_HAS_CASINO_COMPONENTS: InjectionToken<boolean> = new InjectionToken<boolean>(
  'introHasCasinoComponents',
  {
    factory: () => false
  }
);
